
module.exports = function getResource(label, vars = []) {
    let resources = {
        all: 'All '
    };
    return resources[label];
};
